import { Component } from '@angular/core';

@Component({
  selector: 'app-about-details',
  imports: [],
  templateUrl: './about-details.component.html',
  styleUrl: './about-details.component.css',
})
export class AboutDetailsComponent {

}
